<mat-form-field class="multi-labels">
  <mat-label>{{ placeholder }}</mat-label>
  <mat-chip-grid #chipList aria-label="Label selection">
    @for (label of labels; track label) {
      <mat-chip-row
        [removable]="!readOnly && readonlyLabels.indexOf(label) < 0"
        (removed)="remove(label)">
        {{ label }}
        @if (!readOnly) {
          <mat-icon matChipRemove>cancel</mat-icon>
        }
      </mat-chip-row>
    }
    <input #labelInput
      #trigger="matAutocompleteTrigger"
      [disabled]="readOnly"
      [formControl]="labelCtrl"
      [matAutocomplete]="auto"
      [matChipInputFor]="chipList"
      [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
      [matChipInputAddOnBlur]="addOnBlur"
      (matChipInputTokenEnd)="add($event)"
      (focus)="onOpened($event)"
      (paste)="onPaste($event)">
  </mat-chip-grid>
  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)" >
    @for (label of filteredLabels | async; track label) {
      <mat-option [value]="label">
        {{ label }}
      </mat-option>
    }
  </mat-autocomplete>
</mat-form-field>
